// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1633":"e290da67","3376":"cd507b5e","4567":"20085f1e","7318":"b5ab4f46","7793":"52e633f0","8517":"4cf5e1f2","8779":"1d79daef"}[chunkId] + ".chunk.css";
};